/** PC join form (join/components/pc); complements corporateCenter.joinM */
export default {
	translate: {
		success: "Translated",
		failRetry: "Translation failed. Please try again.",
		fail: "Translation failed",
	},
	table: {
		delete: "Remove",
		operation: "Actions",
		type: "Type",
		number: "Number",
		businessDay: "Day",
		businessTime: "Hours",
		emptyBusinessHours: "No business hours yet",
		emptyPhones: "No phone numbers yet",
		emptyServices: "No services yet",
	},
	breadcrumb: {
		myMerchant: "My organization",
		join: "Partner onboarding",
	},
	steps: {
		step1: "Organization details",
		step2: "Qualifications",
		step3: "Pending review",
	},
	page: {
		loading: "Loading…",
		submitting: "Submitting…",
		submitOk: "Submitted. Pending review.",
		submitFail: "Submit failed. Please try again.",
		saving: "Saving…",
		saveOk: "Saved",
		saveFail: "Save failed. Please try again.",
		mockOk: "Test data filled.",
		mockBtn: "Fill test data",
	},
	formRules: {
		registrationCertificate: "Upload the association registration certificate",
		managerName: "Enter the manager’s name",
		managerPhoneNumber: "Enter contact details",
		managerContactType: "Select contact type",
		name: "Enter organization name",
		name_en: "Enter English organization name",
		merchant_type: "Select category",
		business_status: "Business status is required",
		country: "Select country/region",
		region_code: "Select province/city/district",
		address: "Enter detailed address",
		coordinates: "Get coordinates",
		detailTraditional: "Enter details (Traditional Chinese)",
		detailEnglish: "Enter details (English)",
		cover: "Upload cover image",
		managerIntroductionMax: "Introduction must be 500 characters or fewer",
		images: "Upload shop images",
	},
	qualification: {
		orgAddressPh: "Organization address",
		managerContact: "Manager contact",
		placeSelect: "Select",
		emailPh: "Email address",
		mobilePh: "Mobile number",
		uploadAlt: "Upload image",
		certificateTip: "Photo of original certificate; text must be clear",
		pickImage: "Please choose an image file",
		imageMax5mb: "Image must be 5MB or smaller",
		uploadNoUrl: "Upload failed: no image URL returned",
		uploadSuccess: "Image uploaded",
		uploadFail: "Image upload failed",
		protocolInfo: "The agreement will open in a new window",
		validateFail: "Please check the form",
		fileListName: "Registration certificate",
		managerCountryPlaceholder: "+852 Hong Kong, China",
	},
	address: {
		fetchCountryFail: "Could not load country/region list",
		fetchRegionFail: "Could not load district list",
		labelCountry: "Country / region",
		phCountry: "Select country/region",
		phAddressInfo: "Select province / city / district",
		phDetail: "Street address down to door number",
		phDetailEn: "English address",
		phCoords: "Tap to fetch coordinates",
		getBtn: "Get",
		needDetailFirst: "Enter detailed address first",
		needCountry: "Select country/region first",
		needRegion: "Select address (province/city/district) first",
		needDetailCoords: "Enter detailed address first",
		coordsOk: "Coordinates updated",
		coordsEmpty: "No coordinates returned",
		coordsFail: "Could not get coordinates",
		fallbackHK: "Hong Kong, China",
		fallbackTW: "Taiwan, China",
	},
	manager: {
		title: "Manager profile",
		image: "Photo",
		ratioTip: "Aspect ratio 1 : 1.34; a clear front-facing photo is recommended",
		introZh: "Bio",
		introEn: "English bio",
		phIntroZh: "Manager bio (Traditional Chinese)",
		phIntroEn: "Manager bio (English)",
		needIntroFirst: "Enter the manager bio first",
	},
	media: {
		sectionTitle: "Media",
		coverRatioTip: "Aspect ratio 1 : 1.34",
		imagesTip: "Up to 10 images, ratio 1.45:1; drag to reorder from the top-left",
		videoPreviewTitle: "Video preview",
		videoTipPc: "MP4, AVI, MOV, max 50MB; upload one file at a time",
	},
	serviceSection: {
		title: "Services",
		add: "Add service",
		thImage: "Image",
		thName: "Service name",
		thNameEn: "English name",
		thPrice: "Price (USD)",
		noImage: "No image",
		edit: "Edit",
		remove: "Remove",
	},
	serviceModalPc: {
		serviceImage: "Service image",
		imageRatioTip: "1:1 ratio; use a clear service photo",
		titleName: "Service name",
		titleNameEn: "English service name",
		titleIntro: "Summary",
		titleIntroEn: "English summary",
		titleDetailZh: "Details (TC)",
		titleDetailEn: "Details (EN)",
		titlePrice: "Price (USD)",
		phName: "Service name",
		phNameEn: "English service name",
		phIntro: "Short summary",
		phIntroEn: "English summary",
		phDetail: "Service details",
		phPrice: "Price in USD",
		needName: "Enter service name first",
		needIntro: "Enter summary first",
		needDetailZh: "Enter Traditional Chinese details first",
		warnName: "Service name is required",
		warnNameEn: "English name is required",
		warnPrice: "Enter a valid USD price",
		warnIntro: "Summary is required",
		warnIntroEn: "English summary is required",
		warnDetailZh: "Traditional Chinese details are required",
		warnDetailEn: "English details are required",
	},
	businessHourPc: {
		hourPlaceholder: "00 h",
		minutePlaceholder: "00 m",
	},
	previewModal: {
		title: "Preview",
		loading: "Loading…",
	},
	detail: {
		phDetail: "Enter organization details",
	},
	basicInfo: {
		needOrgName: "Enter organization name first",
		needDetailZh: "Enter Traditional Chinese details first",
		serviceUpdated: "Service updated",
		serviceAdded: "Service added",
		deleting: "Deleting service…",
		deleted: "Service deleted",
		deleteFail: "Delete failed. Try again.",
		removed: "Service removed",
		needBusinessHour: "Add at least one business hour",
		needPhone: "Add at least one phone number",
		validateFail: "Please check the form",
	},
	header: {
		logoText: "SeerQ · Partner center",
		logout: "Log out",
		kefuAlt: "Support",
		transferAlt: "Transfer",
		nicknameFallback: "Nickname",
		langHintZh: "Switch to English",
		langHintEn: "Switch to Traditional Chinese",
	},
	actions: {
		back: "Back",
		preview: "Preview",
		save: "Save",
		next: "Next",
		submitReview: "Submit for review",
	},
};
